import { Col, Divider, Row } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import notificationAPI from '~/api/NotificationAPI';
import settingAPI from '~/api/SettingAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import config from '~/config';
import { titleInfoList } from '~/constants';
import styles from './Footer.module.scss';

const cx = classNames.bind(styles);

const Footer = () => {
    const navigate = useNavigate();
    const [listInfo, setListInfo] = useState([]);
    const [copyRight, setCopyRight] = useState('');
    const [policyPost, setPolicyPost] = useState([]);

    const handleGetListInfo = async () => {
        try {
            const params = {
                fields: '["$all"]',
            };
            let final = [];
            const res = await settingAPI.getListInfo(params);
            if (res.code === 200) {
                const rows = res.results.object;
                for (let i = 0; i < rows.length; i++) {
                    // if (rows[i].type === 'ADDRESS') {
                    //     final[0] = { ...rows[i], icon: SVGS.IconLocation };
                    // }
                    if (rows[i].type === 'HOTLINE') {
                        final[1] = { ...rows[i], icon: SVGS.IconPhone };
                    }
                    // if (rows[i].type === 'EMAIL') {
                    //     final[2] = { ...rows[i], icon: SVGS.IconEmail };
                    // }
                    if (rows[i].type === 'WORK_TIME') {
                        final[3] = { ...rows[i], icon: SVGS.IconTimer };
                    }
                    if (rows[i].type === 'COPYRIGHT') {
                        setCopyRight(rows[i]?.value);
                    }
                }
            }
            setListInfo(final);
        } catch (err) {
            console.log(err);
        }
    };

    const handleGetPolicyPostList = async () => {
        try {
            const params = {
                fields: `["$all",{"posts": ["$all" ]}]`,
                filter: `{"title": "POLICY" }`,
            };
            const res = await notificationAPI.getPolicyPostListAPI(params);
            console.log('Khiem', res?.results?.objects?.rows.length);
            if (res?.results?.objects?.rows?.length) {
                console.log('Khiem', res?.results?.objects?.rows[0]?.posts);
                setPolicyPost(res?.results?.objects?.rows[0]?.posts);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetListInfo();
        handleGetPolicyPostList();
        //eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container-top')}>
                <Row justify="center">
                    <Col xs={24} sm={24} lg={11}>
                        <div className={cx('col_home_spa')}>
                            <div>
                                <Row justify="center">
                                    <img
                                        src={IMAGES.NewLogoFooter}
                                        alt=""
                                        style={{ width: '150px' }}
                                        onClick={() => navigate(config.routes.home)}
                                    />
                                </Row>
                            </div>
                            <div>
                                <Row className={cx('title')}>Beauty-ms</Row>
                                <Row className={cx('content')} style={{ marginTop: '15px' }}>
                                    From traditional values, we created Beauty-ms with the desire to bring beauty
                                    Give all women around the world precious moments to love yourself
                                    yourself, to be happy at any time and let pure natural beauty speak.
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={9} lg={3} className={cx('col_thong_tin')}>
                        <Row className={cx('title')}>Category</Row>
                        {titleInfoList?.map((item, index) => {
                            return (
                                <Row
                                    key={index}
                                    className={cx('content', 'item_lien_he')}
                                    onClick={() => navigate(item.path)}
                                >
                                    <span>{item.title}</span>
                                </Row>
                            );
                            // return index !== 1 ? (
                            //     <Row
                            //         key={index}
                            //         className={cx('content', 'item_lien_he')}
                            //         onClick={() => navigate(item.path)}
                            //     >
                            //         <span>{item.title}</span>
                            //     </Row>
                            // ) : (
                            //     <Row key={index} className={cx('item_lien_he')}>
                            //         <span>
                            //             <a href={item.path} target="blank">
                            //                 <div className={cx('content')}> {item.title} </div>
                            //             </a>
                            //         </span>
                            //     </Row>
                            // );
                        })}
                    </Col>
                    <Col xs={24} sm={6} lg={5} className={cx('col_lien_he')}>
                        <Row className={cx('title')}>Contact</Row>
                        {listInfo?.length &&
                            listInfo?.map((item, index) => {
                                return (
                                    <Row key={index} className={cx('content', 'item_lien_he')}>
                                        <span>
                                            <img src={item.icon} alt="" />
                                            {item.value}
                                        </span>
                                    </Row>
                                );
                            })}
                    </Col>
                    <Col xs={24} sm={9} lg={5} className={cx('col_mxh')}>
                        <Row className={cx('title')}>Policy</Row>
                        {policyPost?.map((item, index) => {
                            return (
                                <Row key={index} className={cx('content', 'item_lien_he')}>
                                    <span onClick={() => navigate(`/chinh-sach/${item.slug}`)}>{item.title}</span>
                                </Row>
                            );
                        })}
                    </Col>
                    {/* <Col xs={24} sm={8} lg={4} className={cx('col_mxh')}>
                        <Row className={cx('title')}>Social channels</Row>
                        <Row className={cx('content')}>
                            <img src={SVGS.IconFB} alt="" />
                            <img src={SVGS.IconZalo} alt="" />
                            <img src={SVGS.IconYoutube} alt="" />
                            <img src={SVGS.IconIns} alt="" />
                        </Row>
                        <Row className={cx('logo_CT')}>
                            <img src={SVGS.LogoCongThuong} alt="" />
                        </Row>
                    </Col> */}
                </Row>
            </div>
            <div className={cx('container-bottom')}>
                <Divider style={{ background: 'white' }} />
                <Row justify="center" className={cx('copy_right')}>
                    <span className={cx('text')}>
                        {copyRight}
                        {/* © 2021 VIETNAM BEAUTY AND SPA Co., Ltd. – Address: No. 445 Tran Khat Chan Street, Thanh Ward
                        Nhan, Hai Ba Trung District, Hanoi City - Business Registration Certificate No. 0109534698 issued by the City Department of Business and Investment. Hanoi issued
                        March 1, 2021 – Phone: 0962898383. */}
                    </span>
                    {/* <img src={IMAGES.NewLogoHitek} alt="" /> */}
                </Row>
            </div>
        </div>
    );
};

export default Footer;
